/**
 * Utility function for class names.
 * Uses clsx + tailwind-merge so that a passed override class (e.g. "flex-row")
 * correctly wins over a component's default utility (e.g. base "flex-col").
 */
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
